import { render, staticRenderFns } from "./ResumeOffer.vue?vue&type=template&id=67c2e7c6&scoped=true"
import script from "./ResumeOffer.vue?vue&type=script&lang=js"
export * from "./ResumeOffer.vue?vue&type=script&lang=js"
import style0 from "./ResumeOffer.vue?vue&type=style&index=0&id=67c2e7c6&prod&lang=css"
import style1 from "./ResumeOffer.vue?vue&type=style&index=1&id=67c2e7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2e7c6",
  null
  
)

export default component.exports